/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { IBrowserNavigationGateHandler } from "sirius-platform-support-library/shared/browser-events/browser-navigation-gate-handler.interface";
import { RoutingUtilities } from "sirius-platform-support-library/utilities/routing-utilities";
import { TogglesProvider } from "../toggles/toggles-provider";

export const PermanentRedirectNaviationGateHandlerTypeName =
  "PermanentRedirectNavigationGateHandler";

export class PermanentRedirectNavigationGateHandler
  implements IBrowserNavigationGateHandler
{
  public redirectRules: Record<string, any>;
  public togglesProvider: TogglesProvider;
  private readonly window: Window;

  constructor(
    window: Window,
    togglesProvider: TogglesProvider,
    redirectRules: Record<string, any>
  ) {
    this.window = window;
    this.togglesProvider = togglesProvider;
    this.redirectRules = redirectRules;
  }

  getUniqueId(): string {
    return PermanentRedirectNaviationGateHandlerTypeName;
  }

  isNavigationAllowed(url?: string, hardNavigation?: boolean): boolean {
    const normalizedUrl = RoutingUtilities.sanitizeAndParseUrl(url);
    const currentUrlWithoutQueryParams = normalizedUrl.pathname;
    const queryParams = normalizedUrl.search;
    const redirectTarget = this.getRedirectTargetIfExistsAndActive(
      currentUrlWithoutQueryParams
    );

    if (redirectTarget) {
      this.performRedirect(redirectTarget, queryParams);
    }

    return true;
  }

  private getRedirectTargetIfExistsAndActive(url: string): string {
    const rule = this.redirectRules[url];

    if (rule) {
      if (rule.active === true) {
        return rule?.redirectToUrl;
      } else if (rule?.active === false) {
        return null;
      } else {
        this.togglesProvider.isActive(rule?.active).then((isActive) => {
          if (isActive) {
            this.performRedirect(rule?.redirectToUrl);
          }
        });
      }
    }

    return null;
  }

  private performRedirect(redirectTarget: string, queryParams?: string) {
    let nextUrl = redirectTarget;

    if (queryParams) {
      nextUrl = `${nextUrl}${queryParams}`;
    }

    this.window.location.href = nextUrl;
  }
}
